import React from "react";

export interface Props {
  fromPocketId?: string
  toPocketId?: string
}

export default function MoneyKindView(props: Props) {
  let content;
  if (props.fromPocketId && props.toPocketId) {
    content = <div style={{ color: "gray" }}>Перемещение денег</div>;
  } else if (props.fromPocketId) {
    content = <div style={{ color: "blue" }}>Расход денег</div>;
  } else if (props.toPocketId) {
    content = <div style={{ color: "green" }}>Прирост денег</div>;
  } else {
    content = <div style={{ color: "red" }}>Нет движения денег</div>;
  }

  return content;
}
